import { createSelector } from 'reselect';
import { LpReducerStateProps } from './types';

export const lpsSelector = (state: LpReducerStateProps) => state.lps;

export const getAuthorizedLpsSelector = createSelector(
  lpsSelector,
  ({ authorizedLps }) => authorizedLps
);

export const getAuthorizedDSPsSelector = createSelector(
  lpsSelector,
  ({ authorizedDSPs }) => authorizedDSPs
);

export const getAuthorizedLpSelectedSelector = createSelector(
  lpsSelector,
  ({ lpSelected }) => lpSelected
);

export const getAuthorizedEntitiesSelector = createSelector(
  lpsSelector,
  ({ authorizedEntities }) => authorizedEntities
);

export const lpPickerInputSelector = createSelector(
  lpsSelector,
  ({ lpPickerInput }) => lpPickerInput
);
